import { GetterTree } from "vuex";
import { AppState } from "./index";
import { RootState } from "../index";
import { QuestionCategory } from "@/global/interfaces";

export const getters: GetterTree<AppState, RootState> = {
  getQuestionCategories(state): QuestionCategory[] {
    return state.questionCategories;
  },
};
